import { render } from "./InsightsLayout.vue?vue&type=template&id=0d61c65f&ts=true"
import script from "./InsightsLayout.vue?vue&type=script&lang=ts"
export * from "./InsightsLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__